// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3on_x","obliqueLineWrap":"membershipbadge_obliqueLineWrap__Yugri","obliqueLine":"membershipbadge_obliqueLine__2cNSl"};